// Touch events continue through native scrolling, unlike pointer events which
// may be cancelled as soon as the browser takes ownership of a scroll gesture.
(() => {
  const enabled = matchMedia('(hover: none), (pointer: coarse)');
  const states = new Map();
  const gestures = new Map();
  let suppressedClick = null;
  const activeClass = 'rr-card-touch-active';

  function remove(media, state) {
    clearTimeout(state.timer);
    state.image.removeEventListener('load', state.reveal);
    media.classList.remove(activeClass);
    states.delete(media);
  }

  function reset() {
    for (const [media, state] of states) remove(media, state);
    gestures.clear();
    suppressedClick = null;
  }

  function activate(target, id) {
    const media = target?.closest?.('.product-card__media');
    const image = media?.querySelector('.product-card__image--secondary');
    if (!image || !media.isConnected) return;
    let state = states.get(media);
    if (!state) {
      state = { image, fingers: new Set(), timer: null };
      state.reveal = () => {
        if (states.get(media) === state && image.naturalWidth > 0) media.classList.add(activeClass);
      };
      states.set(media, state);
      image.addEventListener('load', state.reveal);
    }
    clearTimeout(state.timer);
    state.fingers.add(id);
    gestures.get(id).media.add(media);
    // Only request the alternate on actual touch intent. Keep the primary
    // visible until the alternate has loaded, including on slow connections.
    image.loading = 'eager';
    if (image.complete) state.reveal();
  }

  document.addEventListener('touchstart', event => {
    if (!enabled.matches) return;
    suppressedClick = null;
    for (const touch of event.changedTouches) {
      gestures.set(touch.identifier, { media: new Set(), started: Date.now(), x: touch.clientX, y: touch.clientY, moved: false, origin: touch.target?.closest?.('.product-card__media') });
      activate(touch.target, touch.identifier);
    }
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', event => {
    if (!enabled.matches) return;
    for (const touch of event.changedTouches) {
      const gesture = gestures.get(touch.identifier);
      if (gesture) {
        if (Math.hypot(touch.clientX - gesture.x, touch.clientY - gesture.y) > 8) gesture.moved = true;
        activate(document.elementFromPoint(touch.clientX, touch.clientY), touch.identifier);
      }
    }
  }, { passive: true, capture: true });

  function release(event) {
    for (const touch of event.changedTouches) {
      const gesture = gestures.get(touch.identifier);
      if (gesture?.origin && gesture.media.has(gesture.origin) && (gesture.moved || Date.now() - gesture.started >= 400)) {
        suppressedClick = { media: gesture.origin, until: Date.now() + 700 };
      }
      for (const media of gesture?.media || []) {
        const state = states.get(media);
        if (!state) continue;
        state.fingers.delete(touch.identifier);
        if (!state.fingers.size) {
          state.timer = setTimeout(() => remove(media, state), 1000);
        }
      }
      gestures.delete(touch.identifier);
    }
  }
  document.addEventListener('touchend', release, { passive: true, capture: true });
  document.addEventListener('touchcancel', release, { passive: true, capture: true });
  // A hold previews; a short stationary tap still follows the original link.
  document.addEventListener('click', event => {
    if (event.detail === 0 || !suppressedClick || Date.now() > suppressedClick.until) return;
    if (event.target?.closest?.('.product-card__media') !== suppressedClick.media) return;
    suppressedClick = null;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, { capture: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
  window.addEventListener('pagehide', reset);
  enabled.addEventListener('change', reset);
})();
